import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';




export function getTipoContenidoComboSuccess(datos) {
  return {type: types.GET_TIPO_CONTENIDO_COMBO_SUCCESS, datos};
}

export function getTipoContenidoCombo(token ) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().TipoContenidoApi.getTipoContenidoCombo( token ).then(datos => {   
        
      dispatch(getTipoContenidoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}